import {React} from 'react';
import {themmeColor} from 'src/constants/constants';
import {
  TAX_RETURN_STATUS_LABELS,
} from 'src/CpaCenterList/components/cpaList.utils';
import {TAX_FILING_STATUS} from 'src/constants/constants';
import PopUp from 'src/DesignSystem/PopUp/PopUp';
import {TaxReturnType } from 'src/store/taxReturns/taxReturns.reducer';
import DownIcon from 'src/icons/DownIcon';
import { stringClipper } from 'src/common/utils';

interface Props {
  isOpen: boolean;
  onClose: () => void
  dataArray: {
    return_id: number;
    return_type: TaxReturnType;
    name: string;
    status: TAX_FILING_STATUS;
  }[];
  setTaxFilingStatusPopUp: (state: boolean) => void;
  setSelectedReturn: (state: {returnId: number, returnType: TaxReturnType}|null) => void;
}

const MultiReturnStatusUpdatePopup = ({isOpen, onClose, dataArray, setTaxFilingStatusPopUp, setSelectedReturn}: Props) => {
  return (
    <PopUp
      style={{width: 414, height: 'auto', borderRadius: 12, border: 1, position: 'absolute', right: 350, top: 100}}
      isOpen={isOpen}
      onClose={onClose}>
      {dataArray.map((data) => {
        const return_name = stringClipper(data.name, 12);
        return (
          <div
            style={{
              backgroundColor: themmeColor.white,
              padding: 16,
              display: 'flex',
              justifyContent: 'space-between',
              borderBottomWidth: 1,
              borderBottomStyle: 'solid',
              borderBottomColor: themmeColor.offWhite,
            }}>
            <div
              style={{
                flex: 0.45,
                display: 'flex',
                justifyContent: 'left',
                alignItems: 'center',
                textAlign: 'left',
                fontSize: 13,
                fontWeight: 600,
              }}>
              {return_name}
            </div>

            <div
              style={{
                backgroundColor: TAX_RETURN_STATUS_LABELS[data.status]?.backColor ?? themmeColor.silver,
                borderRadius: 20,
                flex: 0.5,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'left',
                color: TAX_RETURN_STATUS_LABELS[data.status]?.textColor,
                fontSize: 13,
                fontWeight: 600,
              }}
              onClick={
                () => {
                  setTaxFilingStatusPopUp(true)
                  setSelectedReturn({returnId: data.return_id, returnType: data.return_type})
                }
              }>
              {data.status}
              <DownIcon />
            </div>
          </div>
        )
      })}
    </PopUp>
  );
};

export default MultiReturnStatusUpdatePopup;
